import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=38c9ccdc&scoped=true&"
import script from "./Main.vue?vue&type=script&lang=js&"
export * from "./Main.vue?vue&type=script&lang=js&"
import style0 from "./Main.styl?vue&type=style&index=0&id=38c9ccdc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c9ccdc",
  null
  
)

export default component.exports